import { render, staticRenderFns } from "./associateShare.vue?vue&type=template&id=f60d3e16"
import script from "./associateShare.vue?vue&type=script&lang=js"
export * from "./associateShare.vue?vue&type=script&lang=js"
import style0 from "./associateShare.vue?vue&type=style&index=0&id=f60d3e16&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports